<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";

  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      .hide-content {
        display: block;
      }
      .show-content {
        padding: 0;
        display: block;
      }
      padding-left: 10px;
      padding-right: 10px;
    }

    .btn-submit-save {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      text-align: center;
      padding: 15px;
    }

    .min-gutter {
      .el-form-item {
          /*margin-bottom: 20px;*/
      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .el-form {
    border: 1px solid #eef2f3;
    margin: 15px 10px;
    padding-top: 15px;
    border-radius: 4px;
    position: relative;

    &.active {
      border-color: $activeColor;

      .title-link {
        color: $activeColor;
      }
    }
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }
</style>


<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title">货品管理</h2>
        <ul>
          <li class="list-style" v-for="item in productMenu" @click="setIndexValue(item.key)"
              :class="{ 'active' : index==item.key}"><span>{{ item.name }}</span>
          </li>
          <div class="btn-submit-save">
            <div>
              <el-button type="primary" style="width: 100px" @click.prevent.stop="onSubmit()"
                         :disabled="doing">保存
              </el-button>
            </div>
          </div>
        </ul>
      </div>
      <div class="content-right min-gutter" @scroll="setCurrentTab">
        <h3>{{currentPartName}}</h3>
        <el-form id="form0" class="form-part" :class="{active: index === 0}" ref="baseForm" :rules="baseRules"
                 :model="form" label-width="165px" :validateOnRuleChange="false"
                 style="padding-right: 20px" onsubmit="return false">
          <h2 class="title-link">基础信息设置</h2>
          <div class="hide-content" :class="{'show-content' : index==0}">
            <el-form-item label="货品种类" prop="goodsKind">
              <el-select placeholder="请选择货品种类" v-model="form.goodsKind" @change="goodsKindChange">
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in goodsKindList"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="货品分类" prop="typeId">
              <el-select placeholder="请选择货品分类" v-model="form.typeId" @change="typeIdChange">
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in goodsTypeList"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="货品编号" prop="code" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.code" placeholder="请输入货品编号" :disabled="!!form.id"></oms-input>
            </el-form-item>
            <el-form-item label="厂商货品编码" prop="factoryGoodsCode" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.factoryGoodsCode" :maxlength="50"
                         placeholder="请输入厂商货品编码"></oms-input>
            </el-form-item>
            <el-form-item label="所属经营范围" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <el-select placeholder="请选择经营范围" v-model="form.businessScope">
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in businessScope"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="国家药品标识码" prop="nationGoodsIdentificationCode" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <oms-input type="text" v-model.trim="form.nationGoodsIdentificationCode" :maxlength="50"
                         placeholder="请输入国家药品标识码"></oms-input>
            </el-form-item>
            <el-form-item label="药品本位码" prop="goodsStandardCode" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <oms-input type="text" v-model.trim="form.goodsStandardCode" :maxlength="50"
                         placeholder="请输入药品本位码"></oms-input>
            </el-form-item>
            <el-form-item label="通用名称" prop="name" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.name" placeholder="请输入通用名称"
                         :disabled="isNameDisabled"></oms-input>
            </el-form-item>
            <el-form-item label="通用名称拼音" v-if="action==='edit'" prop="namePhonetic">
              <oms-input type="text" v-model.trim="form.namePhonetic" placeholder="请输入通用名称拼音"></oms-input>
            </el-form-item>
            <el-form-item label="通用名称拼音首字母" v-if="action==='edit'" prop="nameAcronymy">
              <oms-input type="text" v-model.trim="form.nameAcronymy" placeholder="请输入通用名称拼音首字母"></oms-input>
            </el-form-item>
            <el-form-item label="英文名称" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.goodsEnglishName" placeholder="请输入英文名称"></oms-input>
            </el-form-item>
            <el-form-item label="商品名称" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.genericName" placeholder="请输入商品名称"></oms-input>
            </el-form-item>
            <el-form-item label="剂型" prop="dosageForm" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <el-select placeholder="请选择剂型" v-model="form.dosageForm" :disabled="isDosageFormDisabled">
                <el-option :label="item.label" :value="item.key" :key="item.key" v-for="item in dosageForm"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册分类" prop="drugsRegisterType" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <el-select placeholder="请选择注册分类" v-model="form.drugsRegisterType">
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in drugsRegisterType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格/型号" prop="specifications" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.specifications" placeholder="请输入规格/型号"
                         :disabled="idSpecificationsDisabled"></oms-input>
            </el-form-item>
            <el-form-item label="规格/型号简称" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.specificationAbbreviation" placeholder="请输入规格/型号简称"></oms-input>
            </el-form-item>
            <el-form-item label="有效期" prop="expiryNumber" ref="formInput" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <el-row>
                <oms-input type="number" v-model.trim.number="form.expiryNumber" :min="0" placeholder="请输入有效期"
                           class="el-input-group__white">
                  <el-select v-model="form.expiryUnit" slot="append" @change="checkExpiryNumber" placeholder="请选择有效期"
                             style="width:160px">
                    <el-option label="年" :value="0"></el-option>
                    <el-option label="月" :value="1"></el-option>
                    <el-option label="日" :value="2"></el-option>
                  </el-select>
                </oms-input>
              </el-row>
            </el-form-item>
            <el-form-item label="批准文号" prop="approvalNumber" v-if="showField([1,2,3,4,5,6,7,8,0])">
              <oms-input type="text" v-model.trim="form.approvalNumber" placeholder="请输入批准文号"
                         :disabled="isApprovalNumberDisabled"></oms-input>
            </el-form-item>
            <el-form-item label="批准文号有效期 " prop="goodsApprovalNOValidity" v-if="showField([1,2,3,4,5,6,7,8,0])">
              <el-date-picker
                v-model="form.goodsApprovalNOValidity"
                type="date"
                placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="批准文号批准日期" prop="goodsApprovalNumberApprovalDate"
                          v-if="showField([1,2,3,4,5,6,7,8,0])">
              <el-date-picker
                v-model="form.goodsApprovalNumberApprovalDate"
                type="date"
                placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="包装规格" prop="packingSpecification" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.packingSpecification" :disabled="isPackingSpecificationDisabled"
                         placeholder="请输入包装规格"></oms-input>
            </el-form-item>
            <el-form-item label="包装规格简称" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.packingSpecificationsAbbreviation"
                         placeholder="请输入包装规格简称"></oms-input>
            </el-form-item>
            <el-form-item label="包装转换比" prop="packingConversionRatio" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <oms-input type="number" v-model.trim="form.packingConversionRatio" placeholder="请输入包装转换比"></oms-input>
            </el-form-item>

            <el-form-item label="包装转换比单位" prop="packingConversionRatioUnit" v-if="showField([1,2,3,4,5,6,0,0,0])">
              <el-select type="text" placeholder="请选择包装转换比单位" v-model.trim="form.packingConversionRatioUnit">
                <el-option :value="item.key" :key="item.key" :label="item.label"
                           v-for="item in measurementUnitList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最小赋码包装单位" prop="minPackageUnit" v-if="showField([1,2,3,4,5,6,7,8,0])">
              <oms-input type="text" v-model.trim="form.minPackageUnit" :maxlength="50"
                         placeholder="请输入最小赋码包装单位"></oms-input>
            </el-form-item>
            <el-form-item label="最小赋码单位所含最小计价单位数量" prop="minTagUnitCount" class="mini-line-height-label"
                          v-if="showField([1,2,3,4,5,6,7,8,0])">
              <oms-input type="number" v-model.trim="form.minTagUnitCount" :min="0"
                         placeholder="请输入最小赋码单位所含最小计价单位数量" :disabled="isMinTagUnitCountDisabled"></oms-input>
            </el-form-item>

            <el-form-item label="最小计价单位" prop="measurementUnit" v-if="showField([1,2,3,4,5,6,7,8,0])">
              <el-select type="text" placeholder="请选择最小计价单位" v-model.trim="form.measurementUnit">
                <el-option :value="item.key" :key="item.key" :label="item.label"
                           v-for="item in measurementUnitList"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="生产企业名称" prop="factory" v-if="!form.id && showField([1,2,3,4,5,6,7,8,9])">
              <el-select filterable remote placeholder="请输入名称/拼音首字母缩写/系统代码搜索生产企业" :remote-method="getOrgsList"
                         :clearable="true" v-model="form.factory" popperClass="good-selects"
                         @change="setFactory(form.factory)"
                         @click.native="getOrgsList">
                <el-option :value="item.id" :key="item.id" :label="item.name" v-for="item in orgList">
                  <div style="overflow: hidden">
                    <span class="pull-left" style="clear: right">{{item.name}}</span>
                  </div>
                  <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{item.manufacturerCode}}
                      </span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产企业名称" v-if="form.id && showField([1,2,3,4,5,6,7,8,9])">
              <el-select filterable remote placeholder="请输入名称/拼音首字母缩写/系统代码搜索生产企业" :remote-method="getOrgsList"
                         :clearable="true" v-model="form.factory" popperClass="good-selects"
                         @change="setFactory(form.factory)"
                         @click.native="getOrgsList" :disabled="isDisabled">
                <el-option :value="item.id" :key="item.id" :label="item.name" v-for="item in orgList">
                  <div style="overflow: hidden">
                    <span class="pull-left" style="clear: right">{{item.name}}</span>
                  </div>
                  <div style="overflow: hidden" v-show="item.manufacturerCode">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{item.manufacturerCode}}
                      </span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产企业ID" v-if="showField([1,2,3,4,5,6,7,8,9])">
              {{form.factoryId}}
            </el-form-item>
            <el-form-item label="生产企业名称" v-if="showField([1,2,3,4,5,6,7,8,9])">
              {{form.factoryName}}
            </el-form-item>
            <el-form-item label="统一社会信用代码（生产企业）" prop="factoryCreditCode" class="mini-line-height-label"
                          v-if="showField([1,0,3,0,5,0,7,0,9])">
              {{form.factoryCreditCode}}
            </el-form-item>

            <el-form-item label="上市许可持有人名称" prop="vaccineMarketingApprovalPossessorName"
                          v-if="showField([1,0,3,0,5,0,7,0,0])">
              <oms-input type="text" v-model.trim="form.vaccineMarketingApprovalPossessorName"
                         placeholder="请输入上市许可持有人名称" class="el-input-group__white" :maxlength="50">
                <el-select v-model="form.propertyMap.marketingApprovalPossessorType"
                           slot="prepend" placeholder="请选择持有人类型" @change="clearValidate"
                           style="width:160px;">
                  <el-option label="生产企业" value="0"></el-option>
                  <el-option label="自然人" value="1"></el-option>
                </el-select>
              </oms-input>
            </el-form-item>

            <el-form-item label="统一社会信用代码（上市许可持有人）" class="mini-line-height-label"
                          prop="creditCodePossessor" v-if="showField([1,0,3,0,5,0,7,0,0])">
              <oms-input type="text" v-model.trim="form.creditCodePossessor" :maxlength="50"
                         placeholder="请输入统一社会信用代码（上市许可持有人）"></oms-input>
            </el-form-item>


            <el-form-item label="证件类型"
                          prop="certificateType" v-if="showField([1,0,3,0,5,0,7,0,0])">
              <el-select type="text" placeholder="请选择证件类型" v-model.trim="form.certificateType">
                <el-option :value="item.key" :key="item.key" :label="item.label"
                           v-for="item in certificateType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号（上市许可持有人）" class="mini-line-height-label"
                          prop="certificateNo" v-if="showField([1,0,3,0,5,0,7,0,0])">
              <oms-input type="text" v-model.trim="form.certificateNo" :maxlength="50"
                         placeholder="请输入证件号（上市许可持有人）"></oms-input>
            </el-form-item>
            <el-form-item label="货品来源" prop="importation" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <el-radio-group v-model="form.importation" @change="clearValidate">
                <el-radio :label="item.key" v-for="item in importations" :key="item.key">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="国家或地区" prop="origin" v-if="showField([1,2,3,4,5,6,7,8,9])">
              <oms-input type="text" v-model.trim="form.origin" placeholder="请输入国家或地区"
                         :disabled="isOriginDisabled" :maxlength="50"></oms-input>
            </el-form-item>

            <el-form-item label="进口注册证号" prop="registrationNumber" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.registrationNumber" placeholder="请输入进口注册证号"
                         :disabled="isRegistrationNumberDisabled"></oms-input>
            </el-form-item>

            <el-form-item label="进口注册证有效期" prop="registrationNOValidity" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <el-date-picker
                v-model="form.registrationNOValidity"
                type="date"
                placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="进口注册证批准日期" prop="importGoodsApprovalDate" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <el-date-picker
                v-model="form.importGoodsApprovalDate"
                type="date"
                placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="进口批件号" prop="importGoodsInstructionsNumber" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.importGoodsInstructionsNumber"
                         placeholder="请输入进口批件号" :maxlength="50"></oms-input>
            </el-form-item>

            <el-form-item label="进口批件有效期" prop="importGoodsInstructionsDate" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <el-date-picker
                v-model="form.importGoodsInstructionsDate"
                type="date"
                placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp">
              </el-date-picker>
            </el-form-item>


            <el-form-item label="公司名称（中文）" prop="companyChineseName" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.companyChineseName" placeholder="请输入公司名称（中文）"></oms-input>
            </el-form-item>

            <el-form-item label="公司地址（中文）" prop="companyChineseAddress" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.companyChineseAddress" placeholder="请输入公司地址（中文）"></oms-input>
            </el-form-item>

            <el-form-item label="公司地址（英文）" prop="companyEnglishAddress" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.companyEnglishAddress" placeholder="请输入公司地址（英文）"></oms-input>
            </el-form-item>

            <el-form-item label="公司所在国家或地区（英文）" prop="companyEnglishLocation"
                          class="mini-line-height-label" v-if="showField([0,2,0,4,0,6,0,8,0])">
              <oms-input type="text" v-model.trim="form.companyEnglishLocation" placeholder="公司所在国家或地区（英文）"></oms-input>
            </el-form-item>

            <el-form-item label="产品图片" v-show="form.typeId">
              <oms-upload-picture :photoUrl="form.photo" @change="changPhoto"></oms-upload-picture>
            </el-form-item>
          </div>
        </el-form>
        <div v-show="form.typeId">
          <el-form id="form1" class="form-part" :class="{active: index === 1}" ref="storeForm" :rules="storeRules"
                   :model="form" label-width="120px" style="padding-right: 20px">
            <h2 class="title-link">存储信息设置</h2>
            <div class="hide-content" :class="{'show-content' : index==1}">
              <el-form-item label="储存条件" prop="storageConditionId" v-if="showField([1,2,3,4,5,6,7,8,9])">
                <el-select placeholder="请选择储存条件" v-model="form.storageConditionId">
                  <el-option :label="item.label" :value="item.key" :key="item.key"
                             v-for="item in storageCondition"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="0px" v-if="showField([1,2,3,4,5,6,7,8,0])">
                <el-row :gutter="20">
                  <el-col :span="14">
                    <el-form-item label="运输温度" prop="transportStartTemperature">
                      <oms-input type="number" v-model.trim.number="form.transportStartTemperature" placeholder="最低温度"
                                 class="inline-input">
                        <template slot="append">℃</template>
                      </oms-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">-</el-col>
                  <el-col :span="8">
                    <el-form-item prop="transportEndTemperature">
                      <oms-input type="number" v-model.trim.number="form.transportEndTemperature" placeholder="最高温度"
                                 class="inline-input">
                        <template slot="append">℃</template>
                      </oms-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0px" v-if="showField([1,2,3,4,5,6,7,8,0])">
                <el-row :gutter="20">
                  <el-col :span="14">
                    <el-form-item label="存储温度" prop="storageStartTemperature">
                      <oms-input type="number" v-model.trim.number="form.storageStartTemperature" placeholder="最低温度">
                        <template slot="append">℃</template>
                      </oms-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1">-</el-col>
                  <el-col :span="8">
                    <el-form-item prop="storageEndTemperature">
                      <oms-input type="number" v-model.trim.number="form.storageEndTemperature" placeholder="最高温度">
                        <template slot="append">℃</template>
                      </oms-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
          <el-form id="form2" class="form-part" :class="{active: index === 2}" ref="managerForm" :rules="managerRules"
                   :model="form" label-width="160px" style="padding-right: 20px" v-show="goodsType < 4">
            <h2 class="title-link">管理控制</h2>
            <div class="hide-content" :class="{'show-content' : index==2}">
              <el-form-item ref="formItem" label="商品追溯码编号" prop="goodsTrackNo" v-if="showField([1,2,3,4,5,6,7,8,0])">
                <oms-input type="text" v-model.trim="form.goodsTrackNo" :maxlength="20"
                           placeholder="请输入商品追溯码编号"></oms-input>
              </el-form-item>
            </div>
          </el-form>
          <el-form id="form3" class="form-part" :class="{active: index === 3}" ref="dcForm" :rules="dcRules"
                   :model="form" v-show="goodsType < 4"
                   label-width="180px" style="padding-right: 20px">
            <h2 class="title-link" v-if="form.propertyMap">{{showTitle}}专用</h2>
            <div class="hide-content" :class="{'show-content' : index==3}">
              <div v-if="goodsType===1">
                <el-form-item label="是否国家免疫规划疫苗" prop="propertyMap.nationImmuneProjectVaccineFlag"
                              v-if="showField([1,2,0,0,0,0,0,0,0])">
                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"
                             v-model="form.propertyMap.nationImmuneProjectVaccineFlag"></el-switch>
                </el-form-item>
                <el-form-item label="药物使用次剂量" prop="propertyMap.goodsUsedDosage" v-if="showField([1,2,0,0,0,0,0,0,0])">
                  <oms-input type="text" v-model.trim="form.propertyMap.goodsUsedDosage"
                             placeholder="请输入药物使用次剂量"></oms-input>
                </el-form-item>

                <el-form-item label="药物使用剂量单位" prop="propertyMap.goodsUsedDosageUnit"
                              v-if="showField([1,2,0,0,0,0,0,0,0])">
                  <oms-input type="text" v-model.trim="form.propertyMap.goodsUsedDosageUnit"
                             placeholder="请输入药物使用剂量单位"></oms-input>
                </el-form-item>

                <el-form-item label="最小销售包装单元可用人份数" prop="propertyMap.personPortion"
                              v-if="showField([1,2,0,0,0,0,0,0,0])"
                              class="mini-line-height-label">
                  <oms-input type="number" :min="0"
                             v-model.trim.number="form.propertyMap.personPortion"
                             placeholder="请输入最小销售包装单元可用人份数"></oms-input>
                </el-form-item>
              </div>

              <div v-else-if="goodsType===2">
                <el-form-item label="国家基本药物标识"
                              v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.nationBasicDrugsSign"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.nationBasicDrugsSign">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="处方药标识" v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.goodsOtc"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.goodsOtc">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="特殊药品管理分类" prop="propertyMap.specialDrugsFlag"
                              v-if="showField([0,0,0,0,5,6,0,0,0])">
                  <el-select placeholder="请选择特殊药品管理分类" v-model="form.propertyMap.specialDrugsFlag">
                    <el-option :label="item.label" :value="item.key" :key="item.key"
                               v-for="item in specialDrugsType"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="蛋白同化制剂标志"
                              v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.anabolicAgentsSign"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.anabolicAgentsSign">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="运动员慎用" v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.athletesCaution"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.athletesCaution">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="肽类激素制剂标志"
                              v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.peptideHormoneFlag"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.peptideHormoneFlag">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="含特殊药品复方制剂标志"
                              v-if="showField([0,0,3,4,5,6,0,0,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.specialDrugCompoundPreparation"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.specialDrugCompoundPreparation">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else-if="goodsType===3">
                <el-form-item label="注册证号/备案凭证号" prop="propertyMap.registrationRecordNumber"
                              v-if="showField([0,0,0,0,0,0,7,8,0])">
                  <oms-input type="text" v-model.trim="form.propertyMap.registrationRecordNumber"
                             placeholder="请输入注册证号 / 备案凭证号"></oms-input>
                </el-form-item>
                <el-form-item label="注册证号/备案凭证号有效期" prop="propertyMap.goodsRecordNOValidity"
                              v-if="showField([0,0,0,0,0,0,7,8,0])"
                              class="mini-line-height-label">
                  <el-date-picker v-model="form.propertyMap.goodsRecordNOValidity" type="date" placeholder="选择日期"
                                  format="yyyy-MM-dd" value-format="timestamp">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="防震荡标志" v-if="showField([0,0,0,0,0,0,7,8,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.antiShockFlag"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.antiShockFlag">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="防倾斜标志" v-if="showField([0,0,0,0,0,0,7,8,0])">
                  <!--                  <el-switch active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949"-->
                  <!--                             v-model="form.propertyMap.antiTiltFlag"></el-switch>-->
                  <el-radio-group v-model="form.propertyMap.antiTiltFlag">
                    <el-radio :label="item.value" :key="item.label" v-for="item in threeValueList">{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <el-form id="form4" class="form-part" :class="{active: index === 4}" ref="attachmentForm" :model="form"
                   label-width="160px" style="padding-right: 20px" v-show="goodsType < 4">
            <h2 class="title-link">附件上传</h2>
            <div class="hide-content" :class="{'show-content' : index==4}">
              <el-form-item label-width="0" v-if="showField([1,2,3,4,5,6,7,8,0])">
                <el-row style="border-bottom: 1px solid #eee" v-for="item in attachmentTypeList"
                        :key="item.objectType" v-if="showField(item.showType)">
                  <h2 class="h2-title">
                    <div class="left-title">{{item.name}}</div>
                  </h2>
                  <div style="margin-left: 20px" v-if="showField(item.showType)">
                    <oms-upload :fileList="item.attachmentList" uploadUrl="/qingstor/pre" @change="(files) => changeFiles(item, files)"
                                :formData="{ objectId:form.id , objectType: item.objectType}"></oms-upload>
                  </div>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {BaseInfo, Goods} from '../../../../resources';
  import omsUploadPicture from '../../../common/upload/upload.picture.vue';

  export default {
    components: {
      omsUploadPicture
    },
    name: 'editForm',
    props: {
      formItem: {
        type: Object,
        default: {},
        required: true
      },
      title: {
        type: String,
        default: '增加'
      },
      action: {
        type: String,
        default: ''
      },
      actionType: {
        type: Boolean,
        default: true
      },
      getDefaultForm: Function
    },
    data: function () {
      let checkStorageTemperature = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入存储最高温度'));
        } else {
          if (this.form.storageStartTemperature >= value) {
            callback(new Error('存储最高温度必须大于存储最低温度'));
          } else {
            callback();
          }
        }
      };
      let checkTransportTemperature = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入运输最高温度'));
        } else {
          if (this.form.transportStartTemperature >= value) {
            callback(new Error('运输最高温度必须大于运输最低温度'));
          } else {
            callback();
          }
        }
      };

      let checkGoodsCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入货品编码'));
        } else {
          Goods.checkGoodsCode({code: value, goodsId: this.form.id}).then(val => {
            if (!val.data['validateCode']) {
              callback(new Error('输入的货品编码已存在,请重新输入'));
            } else {
              callback();
            }
          });
        }
      };
      let checkExpiryNumber = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入有效期'));
        } else {
          callback();
        }
      };
      let checkMarketingApprovalPossessorType = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入上市许可持有人名称'));
        } else if (value && !this.form.propertyMap.marketingApprovalPossessorType) {
          callback(new Error('请选择上市许可持有人类型'));
        } else {
          callback();
        }
      };
      let checkCode = (rule, value, callback) => {
        if (value !== '' && value !== null) {
          Goods.checkCode({code: value, goodsId: this.form.id}).then(val => {
            if (!val.data['codeCheck']) {
              callback(new Error('输入的追溯码已存在,请重新输入'));
            } else {
              callback();
            }
          });
        } else {
          callback();
        }
      };
      let checkMinTagUnitCount = (rule, value, callback) => {
        if (value && value < 0) {
          callback(new Error('最小赋码单位所含最小计价单位数量不能为负数'));
        } else if (!Number.isInteger(value * 1) || !/^\d+$/.test(value)) {
          callback(new Error('请输入整数'));
        } else {
          callback();
        }
      };
      let checkMackingConversionRatio = (rule, value, callback) => {
        if (value && value < 0) {
          callback(new Error('包装转换比必须不能为负数'));
        } else if (!Number.isInteger(value * 1) || !/^\d+$/.test(value)) {
          callback(new Error('请输入整数'));
        } else {
          callback();
        }
      };
      return {
        form: this.formItem,
        dcRules: {
          'propertyMap.nationImmuneProjectVaccineFlag': [
            {required: true, message: '请选择是否国家免疫规划疫苗', trigger: 'change'}
          ],
          'propertyMap.goodsUsedDosage': [
            {required: true, message: '请输入药物使用次剂量', trigger: 'blur'}
          ],
          'propertyMap.goodsUsedDosageUnit': [
            {required: true, message: '请输入药物使用剂量单位', trigger: 'blur'}
          ],
          'propertyMap.personPortion': [
            {required: true, message: '请输入最小销售包装单元可用人份数', trigger: 'blur'}
          ],
          'propertyMap.nationBasicDrugsSign': [
            {required: true, message: '请选择国家基本药物标识', trigger: 'change'}
          ],
          'propertyMap.goodsOtc': [
            {required: true, message: '请选择处方药标识', trigger: 'change'}
          ],
          'propertyMap.specialDrugsFlag': [
            {required: true, message: '请选择特殊药品管理分类', trigger: 'change'}
          ],
          'propertyMap.anabolicAgentsSign': [
            {required: true, message: '请选择蛋白同化制剂标志', trigger: 'change'}
          ],
          'propertyMap.athletesCaution': [
            {required: true, message: '请选择运动员慎用', trigger: 'change'}
          ],
          'propertyMap.peptideHormoneFlag': [
            {required: true, message: '请选择肽类激素制剂标志', trigger: 'change'}
          ],
          'propertyMap.specialDrugCompoundPreparation': [
            {required: true, message: '请选择含特殊药品复方制剂标志', trigger: 'change'}
          ],
          'propertyMap.registrationRecordNumber': [
            {required: true, message: '请输入注册证号/备案凭证号', trigger: 'blur'}
          ],
          'propertyMap.goodsRecordNOValidity': [
            {required: true, message: '请选择备案凭证号有效期', trigger: 'change'}
          ],
          'propertyMap.antiShockFlag': [
            {required: true, message: '请选择防震荡标志', trigger: 'change'}
          ],
          'propertyMap.antiTiltFlag': [
            {required: true, message: '请选择防倾斜标志', trigger: 'change'}
          ],
        },
        managerRules: {
          goodsTrackNo: [
            {required: true, message: '请输入商品追溯码编号', trigger: 'blur'}
          ]
        },
        storeRules: {
          storageType: [
            {required: true, message: '请选择储存类别', trigger: 'change'}
          ],
          storageConditionId: [
            {required: true, message: '请选择储存条件', trigger: 'change'}
          ],
          storageStartTemperature: [
            {required: true, type: 'number', message: '请输入存储最低温度', trigger: 'blur'}
          ],
          storageEndTemperature: [
            {required: true, type: 'number', message: '请输入存储最高温度', trigger: 'blur'},
            {validator: checkStorageTemperature, trigger: 'blur'}
          ],
          transportStartTemperature: [
            {required: true, type: 'number', message: '请输入运输最低温度', trigger: 'blur'}
          ],
          transportEndTemperature: [
            {required: true, type: 'number', message: '请输入运输最高温度', trigger: 'blur'},
            {validator: checkTransportTemperature, trigger: 'blur'}
          ]
        },
        baseRules: {
          nationGoodsIdentificationCode: [
            {required: true, message: '请输入国家药品标识码', trigger: 'blur'}
          ],
          goodsStandardCode: [
            {required: true, message: '请输入药品本位码', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入通用名称', trigger: 'blur'}
          ],
          namePhonetic: [
            {required: true, message: '请输入通用名称拼音', trigger: 'blur'}
          ],
          nameAcronymy: [
            {required: true, message: '请输入通用名称拼音首字母', trigger: 'blur'}
          ],
          dosageForm: [
            {required: true, message: '请选择剂型', trigger: 'change'}
          ],
          specifications: [
            {required: true, message: '请输入规格/型号', trigger: 'blur'}
          ],
          specificationAbbreviation: [
            {required: true, message: '请输入规格/型号简称', trigger: 'blur'}
          ],
          packingSpecification: [
            {required: true, message: '请输入包装规格', trigger: 'blur'}
          ],
          packingSpecificationsAbbreviation: [
            {required: true, message: '请输入包装规格简称', trigger: 'blur'}
          ],
          packingConversionRatio: [
            {required: true, message: '请输入包装转换比', trigger: 'blur'},
            {validator: checkMackingConversionRatio, trigger: 'blur'}
          ],
          packingConversionRatioUnit: [
            {required: true, message: '请选择包装转换比单位', trigger: 'change'}
          ],
          expiryNumber: [
            {required: true, type: 'number', message: '请输入有效期', trigger: 'blur'},
            {validator: checkExpiryNumber, trigger: 'blur'}
          ],
          approvalNumber: [
            {required: true, message: '请输入批准文号', trigger: 'blur'}
          ],
          goodsApprovalNOValidity: [
            {required: true, message: '请选择批准文号有效期', trigger: 'change'}
          ],
          goodsApprovalNumberApprovalDate: [
            {required: true, message: '请选择批准文号批准日期', trigger: 'change'}
          ],
          minPackageUnit: [
            {required: true, message: '请输入最小赋码包装单位', trigger: 'blur'}
          ],
          minTagUnitCount: [
            {required: true, message: '请输入最小赋码单位所含最小计价单位数量', trigger: 'blur'},
            {validator: checkMinTagUnitCount, trigger: 'blur'}
          ],
          measurementUnit: [
            {required: true, message: '请选择最小计价单位', trigger: 'change'}
          ],
          factory: [
            {required: true, message: '请选择生产企业', trigger: 'change'}
          ],
          factoryCreditCode: [
            {required: true, message: '请输入统一社会信用代码（生产企业）', trigger: 'blur'}
          ],
          vaccineMarketingApprovalPossessorName: [
            {required: true, message: '请输入上市许可持有人名称', trigger: 'blur'},
            {validator: checkMarketingApprovalPossessorType, trigger: 'blur'}
          ],
          importation: [
            {required: true, message: '请选择货品来源', trigger: 'change'}
          ],
          code: [
            {required: true, message: '请输入货品编号', trigger: 'blur'},
            {validator: checkGoodsCode, trigger: 'blur'}
          ],
          goodsKind: [
            {required: true, message: '请选择货品种类', trigger: 'change'}
          ],
          typeId: [
            {required: true, message: '请选择货品分类', trigger: 'change'}
          ],
          origin: [
            {required: true, message: '请输入国家或地区', trigger: 'blur'}
          ],
          factoryGoodsCode: [
            {required: true, message: '请输入厂商货品编码', trigger: 'blur'}
          ],
          drugsRegisterType: [
            {required: true, message: '请选择注册分类', trigger: 'change'}
          ],
          registrationNumber: [
            {required: true, message: '请输入进口注册证号', trigger: 'blur'}
          ],
          registrationNOValidity: [
            {required: true, message: '请选择进口注册证号有效期', trigger: 'change'}
          ],
          importGoodsApprovalDate: [
            {required: true, message: '请输入进口注册证批准日期', trigger: 'change'}
          ],
          importGoodsInstructionsNumber: [
            {required: true, message: '请输入进口批件号', trigger: 'blur'}
          ],
          importGoodsInstructionsDate: [
            {required: true, message: '请选择进口批件有效期', trigger: 'change'}
          ],
          companyChineseName: [
            {required: true, message: '请输入公司名称（中文）', trigger: 'blur'}
          ],
          companyChineseAddress: [
            {required: true, message: '请输入公司地址（中文）', trigger: 'blur'}
          ],
          companyEnglishAddress: [
            {required: true, message: '请输入公司地址（英文）', trigger: 'blur'}
          ],
          companyEnglishLocation: [
            {required: true, message: '公司所在国家或地区（英文）', trigger: 'blur'}
          ]
        },
        currentPartName: '',
        index: 0,
        orgList: [],
        //        saleList: [],
        supplyList: [],
        doing: false,
        photo: {},
        saveKey: 'productForm',
        validatorDoing: false,
        title_ele: [],
        titleOffsetTop: [],
        isNameDisabled: false,
        isDosageFormDisabled: false,
        idSpecificationsDisabled: false,
        isApprovalNumberDisabled: false,
        isPackingSpecificationDisabled: false,
        isMinTagUnitCountDisabled: false,
        isOriginDisabled: false,
        isRegistrationNumberDisabled: false,
        attachmentTypeList: []
      };
    },
    computed: {
      threeValueList() {
        return this.$store.state.threeValueList;
      },
      importations() {
        return this.$getDict('importation');
      },
      goodsTypeList() {
        let goodsTypeList = this.$store.state.goodsTypeList;
        switch (this.form.goodsKind) {
          case '0': {
            return goodsTypeList.slice(0, 6);
          }
          case '1': {
            return goodsTypeList.slice(6, 8);
          }
          case '2': {
            return goodsTypeList.slice(8);
          }
          default: {
            return goodsTypeList;
          }
        }
      },
      goodsKindList() {
        return this.$getDict('goodsKind');
      },
      businessScope() {
        return this.$getDict('scopes');
      },
      dosageForm() {
        return this.$getDict('dosageForm');
      },
      drugsRegisterType() {
        return this.$getDict('drugsRegisterType');
      },
      qualityStandard() {
        return this.$getDict('qualityStandard');
      },
      storageType() {
        return this.$getDict('storageGenre');
      },
      storageCondition() {
        return this.$getDict('storageCondition');
      },
      shipmentPackingUnit() {
        return this.$getDict('shipmentPackingUnit');
      },
      measurementUnitList() {
        return this.$getDict('measurementUnit');
      },
      vaccineSignList() {
        return this.$getDict('vaccineSign');
      },
      minSalesUnit() {
        return this.$getDict('minSalesUnit');
      },
      specialDrugsType() {
        return this.$getDict('specialDrugsType');
      },
      goodsType() {
        let typeId = this.form.typeId;
        if (!typeId) return -1;
        if (typeId <= 2) {
          return 1;
        } else if (typeId <= 6) {
          return 2;
        } else if (typeId <= 8) {
          return 3;
        } else {
          return 4;
        }
      },
      showTitle: function () {
        switch (this.goodsType) {
          case 1:
            return '疫苗';
          case 2:
            return '药品';
          case 3:
            return '器械';
          case 4:
            return '其他';
          default:
            return '';
        }
      },
      certificateType() {
        return this.$getDict('certificateType');
      },
      productMenu() {
        if (!this.form.typeId) return [{name: '基础信息设置', key: 0, checked: false}];
        let ary = [
          {name: '基础信息设置', key: 0, checked: false},
          {name: '存储信息设置', key: 1, checked: false}
        ];
        if (this.goodsType < 4) {
          ary = ary.concat([
            {name: '管理控制', key: 2, checked: false},
            {name: `${this.showTitle}专用`, key: 3, checked: false},
            {name: '附件上传', key: 4, checked: true}
          ]);
        }
        return ary;
      },
      isDisabled() {
        return !!this.form.id;
      }
    },
    watch: {
      formItem: function (val) {
        if (!this.actionType) return;
        this.isNameDisabled = false;
        this.isDosageFormDisabled = false;
        this.idSpecificationsDisabled = false;
        this.isApprovalNumberDisabled = false;
        this.isPackingSpecificationDisabled = false;
        this.isMinTagUnitCountDisabled = false;
        this.isOriginDisabled = false;
        this.isRegistrationNumberDisabled = false;
        this.resetAttachmentTypeList();
        if (!val.id) {
          this.form = JSON.parse(JSON.stringify(val));
        } else {
          this.form = Object.assign({}, this.getDefaultForm(), JSON.parse(JSON.stringify(val)));
          this.photo = {};
          this.isNameDisabled = this.form.name !== '0';
          this.isDosageFormDisabled = this.form.dosageForm !== '0';
          this.idSpecificationsDisabled = this.form.specifications !== '0';
          this.isApprovalNumberDisabled = this.form.approvalNumber !== '0';
          this.isPackingSpecificationDisabled = this.form.packingSpecification !== '0';
          this.isMinTagUnitCountDisabled = this.form.minTagUnitCount !== 0;
          this.isOriginDisabled = this.form.origin !== '0';
          this.isRegistrationNumberDisabled = this.form.registrationNumber !== '0';
          this.attachmentTypeList.forEach(i => {
            i.attachmentList = this.form[i.type] || [];
            i.attachmentList.forEach(i => {
              i.name = i.attachmentFileName;
            });
            i.attachmentIdList = i.attachmentList.map(m => m.attachmentId);
          });
        }
        // 如果储存类别不存在，则设置空值
        if (!this.form.storageType) {
          this.form.storageType = [];
        }
        this.setOrgList();
        //清空表单校验
        this.$nextTick(() => {
          this.clearForm();
        });
        this.index = 0;
        let ele_warp = this.$el.getElementsByClassName('content-right')[0];
        ele_warp.scrollTop = 0;
      },
      index: function () {
        this.productMenu.forEach((item) => {
          if (item.key === this.index) {
            this.currentPartName = item.name;
          }
        });
      },
      'form.propertyMap.marketingApprovalPossessorType'(val) {
        if (!val) {
          let baseRules = this.baseRules;
          delete baseRules.creditCodePossessor;
          delete baseRules.certificateType;
          delete baseRules.certificateNo;
          this.baseRules = Object.assign({}, baseRules);
        } else if (val === '0') {
          let baseRules = this.baseRules;
          delete baseRules.certificateType;
          delete baseRules.certificateNo;
          baseRules.creditCodePossessor = [
            {required: true, message: '请输入统一社会信用代码（上市许可持有人）', trigger: 'blur'}
          ];
          this.baseRules = Object.assign({}, baseRules);
        } else {
          let baseRules = this.baseRules;
          delete baseRules.creditCodePossessor;
          baseRules.certificateType = [
            {required: true, message: '请选择证件类型', trigger: 'change'}
          ];
          baseRules.certificateNo = [
            {required: true, message: '请输入证件号（上市许可持有人）', trigger: 'blur'}
          ];
          this.baseRules = Object.assign({}, baseRules);
        }
      }
    },
    mounted: function () {
      this.currentPartName = this.productMenu[0].name;
    },
    methods: {
      showField(arr) {
        return arr.some(a => (a + '') === this.form.typeId);
      },
      clearValidate() {
        this.$refs['baseForm'].clearValidate();
      },
      checkExpiryNumber() {
        this.$refs['baseForm'].validateField('expiryNumber');
      },
      setCurrentTab(e) {
        let event = e || window.event;
        let target = event.target || e.srcElement;

        !this.title_ele.length && (this.title_ele = target.getElementsByClassName('form-part'));
        if (!this.titleOffsetTop.length) {
          for (let i = 0; i < this.title_ele.length; i++) {
            this.titleOffsetTop.push(this.title_ele[i].offsetTop - 65);
          }
        }

        let scrollTop = target.scrollHeight - target.clientHeight;
        if (target.scrollTop === scrollTop) {
          return;
        }
        for (let i = 0; i < this.titleOffsetTop.length; i++) {
          if (target.scrollTop > this.titleOffsetTop[i] - 20) {
            this.index = i;
          }
        }
      },
      resetForm() {
        this.$refs['baseForm'].resetFields();
        if (this.form.typeId) {
          this.$refs['dcForm'].resetFields();
        }
        this.$refs['managerForm'].resetFields();
        this.$refs['storeForm'].resetFields();
        this.productMenu.forEach(item => {
          item.checked = false;
        });
      },
      goodsKindChange(val) {
        this.form.typeId = '';
        this.typeIdChange();

      },
      typeIdChange() {
        this.clearForm();
        this.resetAttachmentTypeList();
      },
      resetAttachmentTypeList() {
        this.attachmentTypeList = JSON.parse(JSON.stringify(this.$store.state.attachmentTypeList));
        this.form.attachmentIdList = [];
      },
      clearForm() {
        this.$refs['baseForm'] && this.$refs['baseForm'].clearValidate();
        this.$refs['dcForm'] && this.$refs['dcForm'].clearValidate();
        this.$refs['managerForm'] && this.$refs['managerForm'].clearValidate();
        this.$refs['storeForm'] && this.$refs['storeForm'].clearValidate();
        this.$refs['dcForm'] && this.$refs['dcForm'].clearValidate();
      },
      setOrgList: function () {
        if (this.form.factoryId && this.form.factoryName) {
          this.orgList = [];// 置空列表
          this.orgList.push({'id': this.form.factoryId, 'name': this.form.factoryName});
        }
      },
      changPhoto: function (photo) {
        if (photo) {
          this.photo = photo;
          this.form.photoId = this.photo.attachmentId;
          this.form.photo = this.photo.url;
        }
      },
      changeFiles: function (item, fileList) {
        let ids = [];
        fileList.forEach(file => {
          ids.push(file.attachmentId);
        });
        item.attachmentIdList = ids;
      },
      setIndexValue: function (value) {
        this.index = value;
        let ele = document.getElementById('form' + value);
        if (!ele) return;
        let ele_warp = this.$el.getElementsByClassName('content-right')[0];
        let scrollTop = ele_warp.scrollHeight - ele_warp.clientHeight;
        let otp = ele.offsetTop - 65;
        ele_warp && (ele_warp.scrollTop = scrollTop > otp ? otp : scrollTop);
      },
      getOrgsList: function (query) {// 过滤生产厂商列表
        let param = {
          deleteFlag: false,
          keyWord: query,
          orgRelationTypeList: ['1', '2', '3', '4', '5', '6', '7']
        };
        BaseInfo.queryByOrgRelationTypeList(param).then(res => {
          this.orgList = res.data.list;
        });
      },
      setFactory: function (id) {
        if (id) {
          this.orgList.forEach(val => {
            if (val.id === id) {
              this.form.factoryId = val.id;
              this.form.factoryName = val.name;
              this.form.factoryCreditCode = val.creditCode;
            }
          });
        }
      },
      doSave: function () {
        // 获取附件id
        this.form.attachmentIdList = [];
        this.attachmentTypeList.forEach(i => {
          this.form.attachmentIdList.push(...i.attachmentIdList);
        });
        // 校验证照附件
        if (['1', '2', '3', '4', '5', '6', '7', '8'].includes(this.form.typeId)) {
          for (let item of this.attachmentTypeList) {
            if (this.showField(item.showType)) {
              if (!item.attachmentIdList.length) {
                return this.$notify.info(`请上传"${item.name}"附件`);
              }
              this.form.attachmentIdList.push(...item.attachmentIdList);
            }
          }
          if (!this.form.attachmentIdList || !this.form.attachmentIdList.length) {
            return this.$notify.info('请上传附件');
          }
        }
        let self = this;
        this.validatorDoing = false;
        this.doing = true;
        if (this.action === 'add') {
          Goods.save(self.form).then(() => {
            this.doing = false;
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '新增货品"' + self.form.name + '"成功'
            });
            self.$emit('change', self.form);
            self.$emit('right-close');
            this.index = 0;
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '新增货品"' + self.form.name + '"失败'
            });
            this.doing = false;
          });
        } else {
          Goods.update(self.form.id, self.form).then(() => {
            this.doing = false;
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '修改货品"' + self.form.name + '"成功'
            });
            self.$emit('change', self.form);
            self.$emit('right-close');
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '修改货品"' + self.form.name + '"失败'
            });
            this.doing = false;
          });
        }
      },
      validForm(formName, isNext = true, index) {
        let that = this;
        return new Promise(function (resolve, reject) {
          that.$refs[formName].validate((valid) => {
            if (!valid) {
              // that.setIndexValue(index);
              that.formItemErrorView(index);
              reject();
            } else {
              if (isNext) {
                this.index++;
              }
              resolve();
            }
          });
        });
      },
      formItemErrorView(index) {
        let ele_ary = this.$el.getElementsByClassName('el-form-item is-error');
        if (ele_ary && ele_ary.length) {
          let ele_warp = this.$el.getElementsByClassName('content-right')[0];
          let total_scrollTop = ele_warp.scrollHeight - ele_warp.clientHeight;
          let scrollTop = this.getElementTop(ele_ary[0]) - 125;
          if (scrollTop > total_scrollTop) {
            this.index = index;
          }
          ele_warp.scrollTop = scrollTop;
        }
      },
      getElementTop(element) {
        let actualTop = element.offsetTop;
        let current = element.offsetParent;
        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        return actualTop;
      },
      onSubmit: function () {
        this.validatorFormCount = 0;
        this.validatorDoing = true;
        // 表单验证
        this.validForm('baseForm', false, 0).then(() => {
          this.validForm('storeForm', false, 1).then(() => {
            this.validForm('managerForm', false, 2).then(() => {
              if (this.form.typeId && this.form.typeId !== '4') {
                this.validForm('dcForm', false, 3).then(() => {
                  this.doSave();
                });
              } else {
                this.doSave();
              }
            });
          });
        });
      }
    },
    doClose: function () {// 关闭弹窗,重置表单
      this.$emit('close');
      this.$refs['form'].resetFields();
    },
    changeBuyTime: function (date) {
      this.form.buyTime = this.$moment(date).format('YYYY-MM-DD');
    }
  };
</script>
